import { faker } from '@faker-js/faker';
import { Factory } from 'fishery';

import { Item } from './types';

const factory = Factory.define<Item>(() => ({
  customer_groups: Array.from(
    { length: faker.number.int({ max: 2, min: 1 }) },
    () => ({
      customer_groups: Array.from(
        { length: faker.number.int({ max: 2, min: 1 }) },
        () => ({
          customer_groups: [],
          name: faker.company.name(),
          uuid: faker.string.uuid(),
        }),
      ),
      name: faker.company.name(),
      uuid: faker.string.uuid(),
    }),
  ),
  name: faker.company.name(),
  uuid: faker.string.uuid(),
}));

export default factory;
